import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SewWsContentWrapper } from '@sew/ui-components-angular/standalone';
import { CustomBreakpoint } from '../../helpers/breakpoint.helper';
import { BlogPost } from '../../models/blog-posts.model';
import { TagService } from '../../services/tag/tag.service';
import { RouterService } from '../../shared/services/router.service';
import { PostComponent } from '../post/post.component';

@Component({
    selector: 'blog-connected-article-list',
    templateUrl: './connected-article-list.component.html',
    styleUrls: ['./connected-article-list.component.scss'],
    imports: [CommonModule, PostComponent, SewWsContentWrapper],
})
export class ConnectedArticleListComponent {
    @Input() public breakpoint: CustomBreakpoint = 0;
    @Input() public articles: BlogPost[] = [];
    @Input() public header?: string;
    @Input() public imgSrc?: string;

    public constructor(
        private routerService: RouterService,
        private tagService: TagService
    ) {}

    public onPostClicked(post: BlogPost): void {
        this.routerService.navigateArticle(post);
    }

    public onTagClicked(tag: string): void {
        this.tagService.addTag(tag);
        this.routerService.navigateLandingPage();
    }
}
